// import React, { useState } from "react";

// const AdminSellerAllocation = () => {
//   const [formData, setFormData] = useState({
//     companyName: "",
//     sellerName: "",
//     state: "",
//     district: "",
//     brand: "",
//     fromDate: "",
//     toDate: "",
//     selected: "selected",
//   });

//   const [sellers, setSellers] = useState([
//     {
//       id: 1,
//       companyName: "TechCorp",
//       brand: "TechPro",
//       location: "New York, USA",
//       joinDate: "2024-02-10",
//       status: "Allocated",
//       subadmin: "Subadmin A",
//     },
//     {
//       id: 2,
//       companyName: "Gadget World",
//       brand: "GadgetX",
//       location: "California, USA",
//       joinDate: "2024-01-15",
//       status: "Not Allocated",
//       subadmin: "Subadmin B",
//     },
//   ]);

//   const handleChange = (e) => {
//     setFormData({ ...formData, [e.target.name]: e.target.value });
//   };

//   const handleSubmit = () => {
//     if (!formData.companyName || !formData.sellerName || !formData.subadmin) {
//       alert("Please fill all required fields.");
//       return;
//     }
//     console.log("Form Data Submitted:", formData);
//   };

//   const handleSubadminChange = (id, newSubadmin) => {
//     setSellers(
//       sellers.map((seller) =>
//         seller.id === id ? { ...seller, subadmin: newSubadmin } : seller
//       )
//     );
//   };

//   return (
//     <div className="w-full bg-white p-4">
//       <h2 className="mb-4 text-xl font-bold">Admin Seller Allocation</h2>
//       <div className="w-full border-b pb-5">
//         <div className="flex flex-wrap gap-6">
//           {["companyName", "sellerName", "state", "district", "brand", "fromDate", "toDate"].map((field) => (
//             <div key={field} className="space-y-2">
//               <label htmlFor={field} className="font-medium text-gray-700">
//                 {field.replace(/([A-Z])/g, " $1").replace(/^./, (str) => str.toUpperCase())}
//               </label>
//               <input
//                 id={field}
//                 type={field.includes("Date") ? "date" : "text"}
//                 name={field}
//                 value={formData[field]}
//                 onChange={handleChange}
//                 className="w-full rounded border p-2"
//                 placeholder={`Enter ${field}`}
//               />
//             </div>
//           ))}
//         </div>

//         <div className="mt-4">
//           <button onClick={handleSubmit} className="rounded bg-[#05BF02] p-2 px-5 text-white hover:bg-green-700">
//             Search
//           </button>
//         </div>
//       </div>

//       <div className="mt-10 w-full space-y-4">
//         <div className="grid min-w-[800px] grid-cols-[2fr,2fr,2fr,2fr,2fr,2fr,1fr]  pb-2 font-medium text-brand-button-green-bg">
//           <div className="text-center">Company Name</div>
//           <div className="text-center">Brand</div>
//           <div className="text-center">Location</div>
//           <div className="text-center">Join Date</div>
//           <div className="text-center">Status</div>
//           <div className="text-center">Sub Admin</div>
//           <div className="text-center">View</div>
//         </div>

//         {sellers.map((seller) => (
//           <div key={seller.id} className="grid min-w-[800px] grid-cols-[2fr,2fr,2fr,2fr,2fr,2fr,1fr] gap-1 py-2">
//             <div className="rounded-xl border p-2 text-center">{seller.companyName}</div>
//             <div className="rounded-xl border p-2 text-center">{seller.brand}</div>
//             <div className="rounded-xl border p-2 text-center">{seller.location}</div>
//             <div className="rounded-xl border p-2 text-center">{seller.joinDate}</div>
//             <div className="flex w-full items-center justify-center text-center">
//               <span className={`rounded px-2 py-1 text-white ${seller.status === "Allocated" ? "bg-green-500" : "bg-red-500"}`}>
//                 {seller.status}
//               </span>
//             </div>
//             <div className="rounded-xl border p-2 text-center">
//               <select value={seller.subadmin} onChange={(e) => handleSubadminChange(seller.id, e.target.value)} className="w-full text-center">
//                 <option value="Subadmin A">Subadmin A</option>
//                 <option value="Subadmin B">Subadmin B</option>
//                 <option value="Subadmin C">Subadmin C</option>
//               </select>
//             </div>
//             <div className="text-center">
//               <button className="rounded-lg border border-green-600 px-5 py-2 text-center text-xs font-medium text-green-600 shadow-md transition hover:border-green-700 hover:bg-green-700 hover:text-white sm:text-sm">
//                 View
//               </button>
//             </div>
//           </div>
//         ))}
//       </div>
//     </div>
//   );
// };

// export default AdminSellerAllocation;

import React, { useEffect, useState } from "react";
import {
  getSellers,
  getSubAdmins,
  allocateSellerToSubAdmin,
} from "../../ApiCalls/Users";
import { useNavigate } from "react-router-dom";

const AdminSellerAllocation = () => {
  const [formData, setFormData] = useState({
    companyName: "",
    sellerName: "",
    state: "",
    district: "",
    brand: "",
    fromDate: "",
    toDate: "",
    selected: "selected",
    subadmin: "",
  });

  const [sellers, setSellers] = useState([]);
  const [subadmins, setSubadmins] = useState([]);
  const [selectedSubadmin, setSelectedSubadmin] = useState(null);
  const [sellerIds, setSellerIds] = useState([]); 
  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    try {
      const filters = {
        company_name: formData.companyName,
        seller_name: formData.sellerName,
        location: `${formData.state} ${formData.district}`.trim(),
        brand: formData.brand,
        date_from: formData.fromDate,
        date_to: formData.toDate,
        is_active: formData.selected === "selected" ? 1 : 0,
        agent_name: formData.subadmin,
      };
  
      const response = await getSellers(filters);
      setSellers(response.data);
      setSellerIds(response.data.map((seller) => seller.seller_id)); // Store seller IDs for allocation
    } catch (error) {
      console.error("Error fetching sellers:", error);
    }
  };
  
  const handleSubadminChange = async (id, newSubadmin) => {
    try {
      await allocateSellerToSubAdmin({
        seller: id,
        subadmin: newSubadmin,
      });

      await handleSubmit(); // Refresh after allocation
    } catch (error) {
      console.error("Error allocating subadmin:", error);
    }
  };

  const handleAllocateAllSubadminChange = async () => {
    try {
      if(!selectedSubadmin || sellerIds.length === 0) {
        alert("Please select a subadmin and at least one seller to allocate.");
        return;
      }

      await allocateSellerToSubAdmin({
        seller: sellerIds,
        subadmin: selectedSubadmin,
      });
      // console.log("Allocation successful:", response);


      await handleSubmit(); // Refresh after allocation
    } catch (error) {
      console.error("Error allocating subadmin:", error);
    }
  };


  const fetchSubadmins = async () => {
    try {
      const response = await getSubAdmins();
      setSubadmins(response.data);
    } catch (error) {
      console.error("Error fetching subadmins:", error);
    }
  };

  useEffect(() => {
    handleSubmit();
    fetchSubadmins();
  }, []);

  return (
    <div className="w-full bg-white p-4">
      <h2 className="mb-4 text-2xl font-medium text-green-600">
        Seller Allocation
      </h2>

      {/* Filters */}
      <div className="w-full border-b pb-5">
        <div className="flex flex-wrap gap-6">
          {[
            { name: "companyName", label: "Company Name" },
            { name: "sellerName", label: "Seller Name" },
            { name: "state", label: "State" },
            { name: "district", label: "District" },
            { name: "brand", label: "Brand" },
            { name: "fromDate", label: "From Date", type: "date" },
            { name: "toDate", label: "To Date", type: "date" },
          ].map(({ name, label, type }) => (
            <div key={name} className="space-y-2">
              <label htmlFor={name} className="font-medium text-gray-700">
                {label}
              </label>
              <input
                id={name}
                type={type || "text"}
                name={name}
                value={formData[name]}
                onChange={handleChange}
                className="w-full rounded border p-2"
                placeholder={`Enter ${label}`}
              />
            </div>
          ))}

          <div className="space-y-2">
            <label className="font-medium text-gray-700">
              Selected/Unselected
            </label>
            <select
              name="selected"
              value={formData.selected}
              onChange={handleChange}
              className="w-full cursor-pointer rounded border p-2"
            >
              <option value="selected">Selected</option>
              <option value="unselected">Unselected</option>
            </select>
          </div>
        </div>

        <div className="mt-4 flex items-center gap-4">
          <label className="font-medium text-gray-700">Subadmin</label>
          <select
            name="subadmin"
            value={formData.subadmin}
            onChange={handleChange}
            className="max-w-md cursor-pointer rounded border p-2"
          >
            <option value="">Select Subadmin</option>
            {subadmins?.map((sa) => (
              <option key={sa.id} value={sa.first_name}>
                {sa.first_name}
              </option>
            ))}
          </select>

          <button
            onClick={handleSubmit}
            className="rounded bg-[#05BF02] p-2 px-5 text-white hover:bg-green-700"
          >
            Search
          </button>
        </div>
        <div className="flex w-full items-end justify-end gap-4">
          <div className="flex flex-col gap-2">
            <label htmlFor="subadmin" className="font-medium text-gray-700">
              Allocate To SubAdmin
            </label>
            <select
              id="subadmin"
              name="subadmin"
              value={selectedSubadmin}
              onChange={(e) => setSelectedSubadmin(e.target.value)}
              className="max-w-lg cursor-pointer rounded border p-2"
            >
              <option value="">Select Subadmin</option>
              {subadmins?.map((subadmin) => (
                <option key={subadmin.id} value={subadmin.id}>
                  {subadmin.first_name}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={handleAllocateAllSubadminChange}
            className="rounded bg-[#05BF02] p-2 px-5 text-white hover:bg-green-700"
          >
            Allocate to All
          </button>
        </div>
      </div>


      {/* Table */}
      <div className="mt-10 w-full space-y-4">
        <div className="grid min-w-[800px] grid-cols-[2fr,2fr,2fr,2fr,2fr,1fr] pb-2 font-medium text-brand-button-green-bg">
          <div className="text-center">Company Name</div>
          {/* <div className="text-center">Brand</div> */}
          <div className="text-center">Location</div>
          <div className="text-center">Join Date</div>
          <div className="text-center">Status</div>
          <div className="text-center">Sub Admin</div>
          <div className="text-center">View</div>
        </div>

        {sellers.map((seller) => (
          <div
            key={seller.seller_id}
            className="grid min-w-[800px] grid-cols-[2fr,2fr,2fr,2fr,2fr,1fr] gap-1 py-2"
          >
            <div className="rounded-xl border p-2 text-center">
              {seller.seller_name}
            </div>
            {/* <div className="rounded-xl border p-2 text-center">
              {seller.brand}
            </div> */}
            <div className="rounded-xl border p-2 text-center">
              {seller.location}
            </div>
            <div className="rounded-xl border p-2 text-center">
              {seller.date_joined}
            </div>
            <div className="flex w-full items-center justify-center text-center">
              <span
                className={`rounded px-2 py-1 text-white ${
                  seller.is_allocated ? "bg-green-500" : "bg-red-500"
                }`}
              >
                {seller.is_allocated ? "Allocated" : "Not Allocated"}
              </span>
            </div>
            <div className="rounded-xl border p-2 text-center">
              <select
                value={seller.subadmin_id || ""}
                onChange={(e) =>
                  handleSubadminChange(seller.seller_id, e.target.value)
                }
                className="w-full text-center outline-none"
              >
                <option value="">Select Subadmin</option>
                {subadmins?.map((subadmin) => (
                  <option key={subadmin.id} value={subadmin.id}>
                    {subadmin.first_name}
                  </option>
                ))}
              </select>
            </div>
            <div className="text-center">
              <button
                onClick={() =>
                  navigate(`/admin/sellers/view/${seller.seller_id}`)
                }
                className="rounded-lg border border-green-600 px-5 py-2 text-xs font-medium text-green-600 hover:bg-green-700 hover:text-white"
              >
                View
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminSellerAllocation;
